import React from 'react';
import { useTranslation } from 'react-i18next';
import { apiSdk } from '@/httpClient';
import { AgentCreditCardMemberModel } from '@/__generated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import EScottScript from '@/components/EScottScript';
import { ModalUtils } from '@/contexts/ModalWrapper';
import { UNKNOWN_ERROR_MESSAGE } from '@/config';
import Spin from '@/components/Spin';
import { faEdit } from '@fortawesome/free-regular-svg-icons';

declare var SpsvApi: { spsvCardInfoScreen: Function } | null | undefined;

const resetFlags = () => {
  (window as any).SpsvFlg = (function() {
    var makedFlg = false;
    var makeEndFlg = false;
    var tokenResFlg = false;
    var ngFlg = false;
    return {
      getMakedFlg: function() {
        return makedFlg;
      },
      setMakedFlg: function() {
        return (makedFlg = true);
      },
      getMakeEndFlg: function() {
        return makeEndFlg;
      },
      setMakeEndFlg: function() {
        return (makeEndFlg = true);
      },
      getTokenResFlg: function() {
        return tokenResFlg;
      },
      setTokenResFlg: function() {
        return (tokenResFlg = true);
      },
      getNgFlg: function() {
        return ngFlg;
      },
      setNgFlg: function() {
        return (ngFlg = true);
      },
    };
  })();
};
export default function CreditCardForm() {
  const cardId = React.useRef<string>();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [scriptReady, setScriptReady] = React.useState<boolean>(false);
  const [creditCards, setCreditCards] = React.useState<AgentCreditCardMemberModel[]>([]);
  const getAgentCreditCards = () => {
    setLoading(true);
    apiSdk.AgentProfileService.getAgentCreditCardMembers()
      .then(res => {
        setCreditCards(res);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  React.useMemo(() => {
    getAgentCreditCards();
  }, []);

  const createOrUpdateCard = (token: string, card: string) => {
    setLoading(true);
    let api = cardId.current
      ? apiSdk.AgentProfileService.updateCreditCardMember({
          body: {
            cardNo: card,
            token: token,
            id: cardId.current,
          },
        })
      : apiSdk.AgentProfileService.addNewCreditCardMember({
          body: {
            cardNo: card,
            token: token,
          },
        });
    api
      .then(res => {
        if (res.success) {
          getAgentCreditCards();
        } else {
          ModalUtils.error({
            title: 'Error',
            content: t(res.message || UNKNOWN_ERROR_MESSAGE),
          });
        }
      })
      .catch(() => {
        ModalUtils.error({
          title: 'Error',
          content: t(UNKNOWN_ERROR_MESSAGE),
        });
      })
      .finally(() => {
        setLoading(false);
        cardId.current = undefined;
      });
  };
  React.useEffect(() => {
    (window as any).creditCardCallback = (token, card) => {
      createOrUpdateCard(token, card);
      resetFlags();
      document.getElementById('SPSVviewIframe')?.remove();
    };
    return () => {
      delete (window as any).creditCardCallback;
    };
  }, []);
  return (
    <Spin loading={loading}>
      <EScottScript
        onReady={() => {
          setScriptReady(true);
        }}
      />
      <div className="row y-gap-20">
        <div className="col-12 d-flex align-items-center ">
          <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
          <div className="fw-bold text-18 text-blue-1  rounded-2 px-10 text-uppercase">{t('agentRegister_CreditCard')}</div>
          <div style={{ flex: 1, border: '1px dashed #cccccc' }} />
        </div>

        {creditCards.map(card => {
          return (
            <div className="col-3 " key={card.id}>
              <div
                onClick={() => {
                  cardId.current = card.id;
                  SpsvApi?.spsvCardInfoScreen();
                }}
                className="agent-credit-card text-center rounded-2 w-100 cursor-pointer text-14 border-light"
              >
                <div className="edit-btn">
                  <FontAwesomeIcon icon={faEdit} className="text-12 text-white" />
                </div>
                <div className="fw-500 text-14 mt-10">{card.cardNo}</div>
                <div className="text-12 text-dark-1 mb-10">{card.memberId}</div>
              </div>
            </div>
          );
        })}
        {scriptReady ? (
          <div className="col-3">
            <div
              onClick={() => {
                cardId.current = undefined;
                SpsvApi?.spsvCardInfoScreen();
              }}
              className="text-center rounded-2 w-100 cursor-pointer d-flex items-center justify-content-center h-100"
              style={{ border: '1px dashed #cccccc', minHeight: 70 }}
            >
              <FontAwesomeIcon icon={faPlus} className="text-24 text-light-1 mr-5" />
              <div className="text-14 text-light-1">Add new card</div>
            </div>
          </div>
        ) : null}
      </div>
    </Spin>
  );
}
